<template>
    <div>
        <div class="catcher">
            <h1>{{catcher.name}}</h1>
            <p>{{catcher.description}}</p>
            <div v-if="isMyCatcher(catcher.id)" class="options">
                <router-link
                    class="button"
                    :to="{
                            name: 'EditCatcher',
                            params: { id: catcher.id },
                        }"
                >Endre</router-link>
                <a class="button" @click="confirmDelShow = true">Slett</a>
                <DialogDisplay
                    :show="confirmDelShow"
                    :question="confirmDelQuestion"
                    :yes="del"
                    :no="cancelDel"
                    :cancel="cancelDel"
                />
                <TransferControl :catcher="catcher" />
            </div>
        </div>
        <h1>Fangster</h1>
        <CatchList />
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import { Bus, Stops } from '../../common/bus';
import api from '../../common/api';
import url from '../../common/url';
import DialogDisplay from '../common/DialogDisplay.vue';
import TransferControl from './TransferControl.vue';
import CatchList from '../catches/CatchList.vue';

export default {
    components: { CatchList, DialogDisplay, TransferControl },
    data() {
        return {
            isLoading: false,
            filter: {},
            catcher: {},
            confirmDelShow: false,
        };
    },
    async created() {
        Bus.$emit(Stops.NAVBAR, 'CatchList');
        this.isLoading = true;
        const catcher = await api.get(url.getCatcher(this.$route.params.id));
        this.isLoading = false;
        if (catcher.error) return;
        this.catcher = catcher;
        this.loadCatchesFromFilter({ region: this.world, catcher, records: true });
        Bus.$emit(Stops.TITLE_CHANGED, `${catcher.name}`);
    },
    computed: {
        ...mapState('session', ['world']),
        ...mapGetters('session', ['isMyCatcher']),
        confirmDelQuestion() {
            return `Husk at alle fangster må slettes før fiskeren kan slettes. Vil du VIRKELIG slette ${this.catcher.name}?`;
        },
    },
    methods: {
        ...mapActions('session', ['loadProfile']),
        ...mapActions('catches', ['loadCatchesFromFilter']),
        async del() {
            this.confirmDelShow = false;
            this.isLoading = true;
            const result = await api.delete(url.getCatcher(this.catcher.id));
            this.isLoading = false;
            if (!result.error) {
                this.loadProfile();
                this.$router.push({ name: 'ProfilePage' });
                Bus.$emit(Stops.TOAST, 'Fisker slettet');
            }
        },
        cancelDel() {
            this.confirmDelShow = false;
        },
    },
};
</script>
<style lang="scss" scoped>
h1 {
    font-size: 2rem;
    text-align: center;
    padding: 1rem;
}
.catcher {
    background: $backgroundColor;
    margin: 0.2rem;
    border: 1px solid $borderColor;
    border-radius: 0.3rem;
    padding: 0.3rem;
    p {
        padding: 1rem;
    }
    .options {
        text-align: right;
    }
}
</style>
